import type { FirestoreTimestamp, Thread } from "../types"

/**
 * Unix seconds for sorting the Readings list. Prefers a local activity bump
 * (send / inbound reply) over the last `my_threads` snapshot, so order can
 * update without waiting for a refetch.
 */
export function threadRecencySeconds(
  thread: Thread | undefined,
  localSeconds?: number,
): number {
  const ts = thread?.lastMessageAt ?? thread?.createdAt
  const server = typeof ts?._seconds === "number" ? ts._seconds : 0
  const local = typeof localSeconds === "number" ? localSeconds : 0
  return Math.max(server, local)
}

/** Timestamp for the date badge, matching the sort key. */
export function recencyTimestamp(seconds: number): FirestoreTimestamp | undefined {
  if (seconds <= 0) return undefined
  return { _seconds: seconds, _nanoseconds: 0 }
}
